let tabs = $('.single-commune .commune-tab');
let tabOpen =$('.single-commune .tab-open');
$('body').on('click','.single-commune .tab-open', function(e) {
    e.preventDefault();
    let tabId = $(this).attr('href');

    tabs.each(function(index,element) {
        $(element).addClass('hidden');
    })

    tabOpen.each(function(index,element) {
        $(element).removeClass('active');
    })

    $('#'+tabId).removeClass('hidden');
    $(this).addClass('active');
})


// WEBPACK FOOTER //
// ./src/js/app/single-commune.js